// extracted by mini-css-extract-plugin
export default {"article":"OurOfferings_article__m7V6f","header":"OurOfferings_header__LOKSA"};